<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Пользователи админки</div>
            <a class="title-block__btn btn-add btn-primary btn" :href="route_create_page">Добавить
            </a>
        </div>
        <div class="title-block__right d-none d-md-flex">
            <div class="title-block__list">
                <v-select
                    label="Отображение"
                    v-model="view_type"
                    :items="view_type_options"
                    item-title="label"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>
    </div>

    <div class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
            <button class="search-control__input-btn reset-btn">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"
                        fill="currentColor"/>
                </svg>
            </button>
        </div>
    </div>

    <div class="table-responsive">
        <table-element v-if="view_type === 0" :thead="thead" :tbody="tbody" :actions="actions" @deleteItem="deleteItem" @editItem="editItem"></table-element>
        <div v-else class="u-tiles">
            <div v-for="item in tbody" class="u-tile">
                <a v-on:click="editItem({id: item.id})" class="u-tile__edit-link cursor-pointer" title="Редактировать">
                    <img class="u-tile__img" src="/images/avatar_inv.png" alt="">
                    <div class="u-tile__name">{{ item.tbody.email }}</div>
                    <div class="u-tile__position">{{ item.data.group_name }}</div>
                </a>
                <button v-on:click="deleteItem({id: item.id})" class="table-action table-action_delete u-tile__delete reset-btn" title="Удалить"></button>
            </div>
        </div>
    </div>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
    <Alert />
</template>

<script>
import TableElement from "../../../elements/TableElement";
import AdminUser from "../../../models/AdminUser";
import ChangePage from "../../../helpers/ChangePage";
import AdminUserModal from "../../../modals/AdminUserModal";
import PaginationElement from "../../../elements/PaginationElement";
import ListView from "../../../elements/ListView";
import example from "../../../data/example";
import { withPopper } from '../../../utilites.js';
import Alert from "../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "AdminUsersComponent",
    props: {
        route_delete: String,
        route_list: String,
        route_create_page: String,
        route_edit_page: String
    },
    components: {PaginationElement, TableElement, ListView, Alert},
    data: function () {
        return {
            view_type: 0,
            view_type_options: [
                {
                    id: 0,
                    label: 'Список',
                },
                {
                    id: 1,
                    label: 'Плитка'
                }
            ],
            example,
            search: '',
            actions: [
                {
                    text: 'Изменить',
                    emit: 'editItem',
                    svg: `<button class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>`
                },
                {
                    text: 'Удалить',
                    emit: 'deleteItem',
                    svg: `<button class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>`
                }
            ],
            thead: [
                'Логин',
                'Роль'
            ],
            tbody: [],
            admin: new AdminUser({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),
            page: 1,
            limit: 30,
            count: 1,
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        withPopper,
        editItem: function (params) {
            window.location.href = this.route_edit_page+params.id;
        },
        deleteItem: async function (params) {
            if (params.hasOwnProperty('id')) {
                if (params.id === 1) {
                    this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Невозможно удалить данного пользователя!' });
                    return '';
                }

                let confirmation = confirm('Вы уверены что хотите удалить пользователя?');
                if(!confirmation) {
                    return;
                }
                if (confirmation) {
                    this.admin.delete(params.id).then(this.loadTable);
                }
            } else {
                console.log('Error: delete_item_undefined');
            }
        },
        loadTable: async function () {
            let response = await this.admin.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
    },
    watch: {
        search: function () {
            this.loadTable();
        },
        view_type: function () {
            localStorage.setItem('admin_users_page.view_type', this.view_type);
        }
    },
    mounted() {
        this.loadTable();
        if(localStorage.getItem('admin_users_page.view_type') !== null)
        {
            this.view_type = parseInt(localStorage.getItem('admin_users_page.view_type'));
        }
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
